import { Component, OnInit, Input, Output, EventEmitter, Inject, LOCALE_ID } from '@angular/core';
import { DataService } from '../services/data.service';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { createAlertConfig } from '../shared/factoryconfigAlert';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  @Input()
  visible: boolean
  @Output()
  visibleChange = new EventEmitter();

  oldPassword: string;
  password: string;
  confirmPassword: string;

  errors: any[];

  constructor(@Inject(LOCALE_ID) public locale: string, 
  private dataService: DataService, 
  private alertService: NwbAlertService) { }

  ngOnInit() {
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.errors = undefined;
    this.password = undefined;
    this.confirmPassword = undefined;
  }

  changePassword() {
    this.errors = [];
    if (this.oldPassword === undefined || this.oldPassword.length === 0) {
      if (this.locale == 'it') {
        this.errors = [{ description: "La password è richiesta" }];
      } else {
        this.errors = [{ description: "Password is mandatory" }];
      }
      return;
    
    }
    if (!this.password || !this.confirmPassword || this.password !== this.confirmPassword) {
      if (this.locale == 'it') {
        this.errors = [{ description: "Password e conferma password non contengono lo stesso valore" }];
      } else {
        this.errors = [{ description: "Password and confirm password are not equal" }];
      }
      return;
    }

    this.dataService.changePassword(this.oldPassword, this.password).subscribe(t => {
      if (t.succeeded) {
        this.close();
        if (this.locale == 'it') {
          this.alertService.open(createAlertConfig("Password modificata", true)).afterClosed().subscribe();
        }
        else {
          this.alertService.open(createAlertConfig("Password updated", true)).afterClosed().subscribe();
        }
        
      } else {        
        this.errors = t.errors;
      }
    }, _err => {
      if (this.locale == 'it') {
        this.errors = [{ description: "Errore inatteso durante il cambio password. Riprovare più tardi. Se l'errore persiste contattare l'assistenza" }];
      } else {
        this.errors = [{ description: "Error unexpected while change password. Try Again later. If this error persist contact the support" }];
      }
    });
  }

}
